"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Origin = exports.ResponseCode = exports.CartType = void 0;
var CartType;
(function (CartType) {
    CartType["FLASH_SALES"] = "fs";
    CartType["MARKETPLACE"] = "marketplace";
    CartType["LEGACY"] = "leg";
    CartType["NEW"] = "new";
})(CartType || (exports.CartType = CartType = {}));
var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["SUCCESS"] = 200] = "SUCCESS";
    ResponseCode[ResponseCode["CREATED"] = 201] = "CREATED";
    ResponseCode[ResponseCode["EMPTY"] = 204] = "EMPTY";
    ResponseCode[ResponseCode["EXPIRED"] = 260] = "EXPIRED";
    ResponseCode[ResponseCode["FROZEN"] = 261] = "FROZEN";
    ResponseCode[ResponseCode["REOPEN"] = 262] = "REOPEN";
    ResponseCode[ResponseCode["ONBOARDING_REDIRECT"] = 263] = "ONBOARDING_REDIRECT";
    ResponseCode[ResponseCode["CLIENT_ERROR"] = 400] = "CLIENT_ERROR";
    ResponseCode[ResponseCode["ACCESS_DENY"] = 401] = "ACCESS_DENY";
    ResponseCode[ResponseCode["INCOMPATIBLE"] = 409] = "INCOMPATIBLE";
    ResponseCode[ResponseCode["INVALID_CART"] = 412] = "INVALID_CART";
    ResponseCode[ResponseCode["MORE_THAN_ONE"] = 429] = "MORE_THAN_ONE";
    ResponseCode[ResponseCode["UNEXPECTED"] = 500] = "UNEXPECTED";
})(ResponseCode || (exports.ResponseCode = ResponseCode = {}));
var Origin;
(function (Origin) {
    Origin[Origin["CATALOG"] = 0] = "CATALOG";
    Origin[Origin["SEARCH"] = 1] = "SEARCH";
})(Origin || (exports.Origin = Origin = {}));
